import { render, staticRenderFns } from "./ScrollArrowUp.vue?vue&type=template&id=03ed9bc2&"
import script from "./ScrollArrowUp.vue?vue&type=script&lang=js&"
export * from "./ScrollArrowUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports